/**
 * Builds the dataset label from an optional month name and a year name.
 * Only prepends the month (and a separating space) when a month name is given,
 * so that a year-only selection does not end up with a leading space.
 * @param monthName - Name of the selected month, or an empty string/undefined when no month is selected
 * @param yearName - Name of the selected year
 */
export const buildDataSetLabel = (monthName: string | undefined, yearName: string): string => {
	return monthName ? monthName + ' ' + yearName : yearName;
};
